var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 504.125 504.125",
    style: {
      enableBackground: "new 0 0 504.125 504.125"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B3D1B"
    },
    d: "M499.665,470.899c5.955,5.955,5.939,15.612,0,21.567l-7.2,7.184c-5.971,5.955-15.612,5.955-21.575,0 L229.132,257.899c-5.955-5.955-5.955-15.612,0-21.567l7.192-7.184c5.963-5.955,15.612-5.955,21.567,0L499.665,470.899z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C2C15"
    },
    d: "M236.323,229.149l-7.192,7.184c-5.955,5.955-5.955,15.612,0,21.567l119.532,119.54 c5.955,5.955,15.612,5.939,21.567,0l7.184-7.2c5.971-5.955,5.971-15.612,0-21.551l-119.517-119.54 C251.943,223.194,242.286,223.194,236.323,229.149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C17E52"
    },
    d: "M284.341,220.886c1.583,1.599,1.615,4.198,0,5.782l-57.683,57.691 c-1.583,1.583-4.175,1.583-5.758-0.016l-8.027-8.019c-1.575-1.583-1.575-4.151,0-5.75l57.683-57.691 c1.615-1.583,4.183-1.583,5.782,0L284.341,220.886z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B3D1B"
    },
    d: "M338.337,132.514c5.947,5.986,5.947,15.628,0,21.583L154.104,338.331 c-5.955,5.971-15.612,5.971-21.583,0l-97.95-97.95c-5.971-5.971-5.971-15.612,0-21.567L218.805,34.581 c5.955-5.955,15.612-5.971,21.567,0L338.337,132.514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#875023"
    },
    d: "M218.805,34.581L34.572,218.806c-5.971,5.955-5.971,15.596,0,21.567l26.065,26.081 c5.955,5.955,15.604,5.939,21.567,0L266.453,82.205c5.947-5.971,5.947-15.612,0-21.583l-26.08-26.041 C234.417,28.61,224.76,28.626,218.805,34.581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD6F40"
    },
    d: "M171.63,328.902c5.963,5.955,5.963,15.612,0,21.567l-17.983,17.983 c-5.947,5.939-15.604,5.955-21.559,0L4.466,240.822c-5.955-5.955-5.955-15.612,0-21.567l17.975-17.983 c5.947-5.939,15.604-5.939,21.559,0L171.63,328.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C17E52"
    },
    d: "M4.466,240.822c-5.955-5.955-5.955-15.612,0-21.567l17.975-17.983c5.947-5.939,15.604-5.939,21.559,0 l127.622,127.63"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD6F40"
    },
    d: "M368.435,132.105c5.971,5.939,5.971,15.596,0,21.551l-17.967,17.967 c-5.955,5.955-15.604,5.955-21.567,0L201.279,44.009c-5.947-5.955-5.947-15.612,0-21.567l17.983-17.967 c5.955-5.955,15.588-5.955,21.559,0L368.435,132.105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C17E52"
    },
    d: "M201.279,44.009c-5.947-5.955-5.947-15.612,0-21.567l17.983-17.967 c5.955-5.955,15.588-5.955,21.559,0l127.606,127.63"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95A4A5"
    },
    d: "M269.8,477.792c0,5.86-4.742,10.602-10.602,10.602H54.327c-5.86,0-10.602-4.742-10.602-10.602V416.58 c0-5.86,4.742-10.602,10.602-10.602h204.879c5.86,0,10.602,4.742,10.602,10.602v61.212H269.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACBBBC"
    },
    d: "M259.206,405.978H54.327c-5.86,0-10.602,4.742-10.602,10.602v13.265 c0,5.86,4.742,10.602,10.602,10.602h204.879c5.86,0,10.602-4.742,10.602-10.602V416.58 C269.8,410.719,265.066,405.978,259.206,405.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#768889"
    },
    d: "M313.541,492.317c0,6.522-5.285,11.8-11.8,11.8H11.808c-6.522,0-11.8-5.278-11.8-11.8l0,0 c0-6.506,5.278-11.8,11.8-11.8h289.942C308.255,480.517,313.541,485.81,313.541,492.317L313.541,492.317z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuction);
export default __webpack_public_path__ + "static/media/auction.1e0ede7fd9ec5be1e6757c4cb4124163.svg";
export { ForwardRef as ReactComponent };